import HttpRequest from '../../lib/HttpRequest'

const api = new HttpRequest('geo-lookup')
const actions = {
  addresses ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get('addresses-from-postcode', payload)
        .then(({ data }) => {
          commit('geo-lookup/addresses', data)
          resolve(data)
        })
        .catch(err => reject(err))
    })
  },

  countries ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get('country-list', payload)
        .then(({ data }) => {
          commit('geo-lookup/countries', data)
          resolve(data)
        })
        .catch(err => reject(err))
    })
  }
}

export default actions
